import { css } from "styled-components";

export const baseResetCSSWrapper = css`
  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  [hidden],
  template {
    display: none;
  }
  a {
    background-color: transparent;
  }
  a:active,
  a:hover {
    outline: 0;
  }
  abbr[title] {
    border-bottom: 1px dotted;
  }
  b,
  strong {
    font-weight: 700;
  }
  dfn {
    font-style: italic;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  mark {
    background: #ff0;
    color: #000;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sup {
    top: -0.5em;
  }
  sub {
    bottom: -0.25em;
  }
  img {
    border: 0;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  figure {
    margin: 1em 40px;
  }
  hr {
    box-sizing: content-box;
    height: 0;
  }
  pre {
    overflow: auto;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }
  button {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
  }
  button[disabled],
  html input[disabled] {
    cursor: default;
  }
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  input {
    line-height: normal;
  }
  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
  }
  input[type="search"] {
    -webkit-appearance: textfield;
    box-sizing: content-box;
  }
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }
  textarea {
    overflow: auto;
  }
  optgroup {
    font-weight: 700;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
  }
  *,
  :after,
  :before {
    box-sizing: border-box;
  }
  html {
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  body {
    font-family: "UI Sans", "Lato", sans-serif;
    font-size: 15px;
    line-height: 1.7142857143;
    color: #494949;
    background-color: #fff;
  }
  button,
  input,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  a {
    color: #494949;
    text-decoration: none;
  }
  a:hover {
    color: #636363;
    text-decoration: underline;
  }
  a:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  figure {
    margin: 0;
  }
  img {
    vertical-align: middle;
  }
  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
  }
  .img-rounded {
    border-radius: 0;
  }
  .img-thumbnail {
    padding: 4px;
    line-height: 1.7142857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    max-width: 100%;
    height: auto;
  }
  .img-circle {
    border-radius: 50%;
  }
  hr {
    margin-top: 25px;
    margin-bottom: 25px;
    border: 0;
    border-top: 1px solid #eee;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .sr-only-focusable:active,
  .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
  }
  [role="button"] {
    cursor: pointer;
  }
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: inherit;
    font-weight: 400;
    line-height: 1.1;
    color: inherit;
  }
  .h1 .small,
  .h1 small,
  .h2 .small,
  .h2 small,
  .h3 .small,
  .h3 small,
  .h4 .small,
  .h4 small,
  .h5 .small,
  .h5 small,
  .h6 .small,
  .h6 small,
  h1 .small,
  h1 small,
  h2 .small,
  h2 small,
  h3 .small,
  h3 small,
  h4 .small,
  h4 small,
  h5 .small,
  h5 small,
  h6 .small,
  h6 small {
    font-weight: 400;
    line-height: 1;
    color: #777;
  }
  .h1,
  .h2,
  .h3,
  h1,
  h2,
  h3 {
    margin-top: 25px;
    margin-bottom: 12.5px;
  }
  .h1 .small,
  .h1 small,
  .h2 .small,
  .h2 small,
  .h3 .small,
  .h3 small,
  h1 .small,
  h1 small,
  h2 .small,
  h2 small,
  h3 .small,
  h3 small {
    font-size: 65%;
  }
  .h4,
  .h5,
  .h6,
  h4,
  h5,
  h6 {
    margin-top: 12.5px;
    margin-bottom: 12.5px;
  }
  .h4 .small,
  .h4 small,
  .h5 .small,
  .h5 small,
  .h6 .small,
  .h6 small,
  h4 .small,
  h4 small,
  h5 .small,
  h5 small,
  h6 .small,
  h6 small {
    font-size: 75%;
  }
  .h1,
  h1 {
    font-size: 39px;
  }
  .h2,
  h2 {
    font-size: 32px;
  }
  .h3,
  h3 {
    font-size: 26px;
  }
  .h4,
  h4 {
    font-size: 19px;
  }
  .h5,
  h5 {
    font-size: 15px;
  }
  .h6,
  h6 {
    font-size: 13px;
  }
  p {
    margin: 0 0 12.5px;
  }
`;

export const baseTextCSSWrapper = css`
  .lead {
    margin-bottom: 25px;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.4;
  }
  @media (min-width: 767px) {
    .lead {
      font-size: 22.5px;
    }
  }
  .small,
  small {
    font-size: 86%;
  }
  .mark,
  mark {
    background-color: #fcf8e3;
    padding: 0.2em;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .text-justify {
    text-align: justify;
  }
  .text-nowrap {
    white-space: nowrap;
  }
  .text-lowercase {
    text-transform: lowercase;
  }
  .initialism,
  .text-uppercase {
    text-transform: uppercase;
  }
  .text-capitalize {
    text-transform: capitalize;
  }
  .text-muted {
    color: #777;
  }
  .text-primary {
    color: #337ab7;
  }
  a.text-primary:focus,
  a.text-primary:hover {
    color: #286090;
  }
  .text-success {
    color: #3c763d;
  }
  a.text-success:focus,
  a.text-success:hover {
    color: #2b542c;
  }
  .text-info {
    color: #31708f;
  }
  a.text-info:focus,
  a.text-info:hover {
    color: #245269;
  }
  .text-warning {
    color: #8a6d3b;
  }
  a.text-warning:focus,
  a.text-warning:hover {
    color: #66512c;
  }
  .text-danger {
    color: #f80000;
  }
  a.text-danger:focus,
  a.text-danger:hover {
    color: #c50000;
  }
  .bg-primary {
    color: #fff;
    background-color: #337ab7;
  }
  a.bg-primary:focus,
  a.bg-primary:hover {
    background-color: #286090;
  }
  .bg-success {
    background-color: #dff0d8;
  }
  a.bg-success:focus,
  a.bg-success:hover {
    background-color: #c1e2b3;
  }
  .bg-info {
    background-color: #d9edf7;
  }
  a.bg-info:focus,
  a.bg-info:hover {
    background-color: #afd9ee;
  }
  .bg-warning {
    background-color: #fcf8e3;
  }
  a.bg-warning:focus,
  a.bg-warning:hover {
    background-color: #f7ecb5;
  }
  .bg-danger {
    background-color: #ffe6e7;
  }
  a.bg-danger:focus,
  a.bg-danger:hover {
    background-color: #ffb3b6;
  }
  .page-header {
    padding-bottom: 11.5px;
    margin: 50px 0 25px;
    border-bottom: 1px solid #eee;
  }
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 12.5px;
  }
  ol ol,
  ol ul,
  ul ol,
  ul ul {
    margin-bottom: 0;
  }
  .list-inline,
  .list-unstyled {
    padding-left: 0;
    list-style: none;
  }
  .list-inline {
    margin-left: -5px;
  }
  .list-inline > li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
  }
  dl {
    margin-top: 0;
    margin-bottom: 25px;
  }
  dd,
  dt {
    line-height: 1.7142857143;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin-left: 0;
  }
  .dl-horizontal dd:after,
  .dl-horizontal dd:before {
    content: " ";
    display: table;
  }
  .dl-horizontal dd:after {
    clear: both;
  }
  @media (min-width: 767px) {
    .dl-horizontal dt {
      float: left;
      width: 160px;
      clear: left;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .dl-horizontal dd {
      margin-left: 180px;
    }
  }
  abbr[data-original-title],
  abbr[title] {
    cursor: help;
    border-bottom: 1px dotted #777;
  }
  .initialism {
    font-size: 90%;
  }
  blockquote {
    padding: 12.5px 25px;
    margin: 0 0 25px;
    font-size: 18.75px;
    border-left: 5px solid #eee;
  }
  blockquote ol:last-child,
  blockquote p:last-child,
  blockquote ul:last-child {
    margin-bottom: 0;
  }
  blockquote .small,
  blockquote footer,
  blockquote small {
    display: block;
    font-size: 80%;
    line-height: 1.7142857143;
    color: #777;
  }
  blockquote .small:before,
  blockquote footer:before,
  blockquote small:before {
    content: "â€”Â ";
  }
  .blockquote-reverse,
  blockquote.pull-right {
    padding-right: 15px;
    padding-left: 0;
    border-right: 5px solid #eee;
    border-left: 0;
    text-align: right;
  }
  .blockquote-reverse .small:before,
  .blockquote-reverse footer:before,
  .blockquote-reverse small:before,
  blockquote.pull-right .small:before,
  blockquote.pull-right footer:before,
  blockquote.pull-right small:before {
    content: "";
  }
  .blockquote-reverse .small:after,
  .blockquote-reverse footer:after,
  .blockquote-reverse small:after,
  blockquote.pull-right .small:after,
  blockquote.pull-right footer:after,
  blockquote.pull-right small:after {
    content: "Â â€”";
  }
  address {
    margin-bottom: 25px;
    font-style: normal;
    line-height: 1.7142857143;
  }
`;

export const baseGridCSSWrapper = css`
  .container {
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
  .container:after,
  .container:before {
    content: " ";
    display: table;
  }
  .container:after {
    clear: both;
  }
  @media (min-width: 767px) {
    .container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    .container {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    .container {
      width: 1170px;
    }
  }
  .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
  .container-fluid:after,
  .container-fluid:before {
    content: " ";
    display: table;
  }
  .container-fluid:after {
    clear: both;
  }
  .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  .row:after,
  .row:before {
    content: " ";
    display: table;
  }
  .row:after {
    clear: both;
  }
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-13,
  .col-lg-14,
  .col-lg-15,
  .col-lg-16,
  .col-lg-17,
  .col-lg-18,
  .col-lg-19,
  .col-lg-20,
  .col-lg-21,
  .col-lg-22,
  .col-lg-23,
  .col-lg-24,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-13,
  .col-md-14,
  .col-md-15,
  .col-md-16,
  .col-md-17,
  .col-md-18,
  .col-md-19,
  .col-md-20,
  .col-md-21,
  .col-md-22,
  .col-md-23,
  .col-md-24,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-13,
  .col-sm-14,
  .col-sm-15,
  .col-sm-16,
  .col-sm-17,
  .col-sm-18,
  .col-sm-19,
  .col-sm-20,
  .col-sm-21,
  .col-sm-22,
  .col-sm-23,
  .col-sm-24,
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12,
  .col-xs-13,
  .col-xs-14,
  .col-xs-15,
  .col-xs-16,
  .col-xs-17,
  .col-xs-18,
  .col-xs-19,
  .col-xs-20,
  .col-xs-21,
  .col-xs-22,
  .col-xs-23,
  .col-xs-24 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12,
  .col-xs-13,
  .col-xs-14,
  .col-xs-15,
  .col-xs-16,
  .col-xs-17,
  .col-xs-18,
  .col-xs-19,
  .col-xs-20,
  .col-xs-21,
  .col-xs-22,
  .col-xs-23,
  .col-xs-24 {
    float: left;
  }
  .col-xs-1 {
    width: 4.1666666667%;
  }
  .col-xs-2 {
    width: 8.3333333333%;
  }
  .col-xs-3 {
    width: 12.5%;
  }
  .col-xs-4 {
    width: 16.6666666667%;
  }
  .col-xs-5 {
    width: 20.8333333333%;
  }
  .col-xs-6 {
    width: 25%;
  }
  .col-xs-7 {
    width: 29.1666666667%;
  }
  .col-xs-8 {
    width: 33.3333333333%;
  }
  .col-xs-9 {
    width: 37.5%;
  }
  .col-xs-10 {
    width: 41.6666666667%;
  }
  .col-xs-11 {
    width: 45.8333333333%;
  }
  .col-xs-12 {
    width: 50%;
  }
  .col-xs-13 {
    width: 54.1666666667%;
  }
  .col-xs-14 {
    width: 58.3333333333%;
  }
  .col-xs-15 {
    width: 62.5%;
  }
  .col-xs-16 {
    width: 66.6666666667%;
  }
  .col-xs-17 {
    width: 70.8333333333%;
  }
  .col-xs-18 {
    width: 75%;
  }
  .col-xs-19 {
    width: 79.1666666667%;
  }
  .col-xs-20 {
    width: 83.3333333333%;
  }
  .col-xs-21 {
    width: 87.5%;
  }
  .col-xs-22 {
    width: 91.6666666667%;
  }
  .col-xs-23 {
    width: 95.8333333333%;
  }
  .col-xs-24 {
    width: 100%;
  }
  .col-xs-pull-0 {
    right: auto;
  }
  .col-xs-pull-1 {
    right: 4.1666666667%;
  }
  .col-xs-pull-2 {
    right: 8.3333333333%;
  }
  .col-xs-pull-3 {
    right: 12.5%;
  }
  .col-xs-pull-4 {
    right: 16.6666666667%;
  }
  .col-xs-pull-5 {
    right: 20.8333333333%;
  }
  .col-xs-pull-6 {
    right: 25%;
  }
  .col-xs-pull-7 {
    right: 29.1666666667%;
  }
  .col-xs-pull-8 {
    right: 33.3333333333%;
  }
  .col-xs-pull-9 {
    right: 37.5%;
  }
  .col-xs-pull-10 {
    right: 41.6666666667%;
  }
  .col-xs-pull-11 {
    right: 45.8333333333%;
  }
  .col-xs-pull-12 {
    right: 50%;
  }
  .col-xs-pull-13 {
    right: 54.1666666667%;
  }
  .col-xs-pull-14 {
    right: 58.3333333333%;
  }
  .col-xs-pull-15 {
    right: 62.5%;
  }
  .col-xs-pull-16 {
    right: 66.6666666667%;
  }
  .col-xs-pull-17 {
    right: 70.8333333333%;
  }
  .col-xs-pull-18 {
    right: 75%;
  }
  .col-xs-pull-19 {
    right: 79.1666666667%;
  }
  .col-xs-pull-20 {
    right: 83.3333333333%;
  }
  .col-xs-pull-21 {
    right: 87.5%;
  }
  .col-xs-pull-22 {
    right: 91.6666666667%;
  }
  .col-xs-pull-23 {
    right: 95.8333333333%;
  }
  .col-xs-pull-24 {
    right: 100%;
  }
  .col-xs-push-0 {
    left: auto;
  }
  .col-xs-push-1 {
    left: 4.1666666667%;
  }
  .col-xs-push-2 {
    left: 8.3333333333%;
  }
  .col-xs-push-3 {
    left: 12.5%;
  }
  .col-xs-push-4 {
    left: 16.6666666667%;
  }
  .col-xs-push-5 {
    left: 20.8333333333%;
  }
  .col-xs-push-6 {
    left: 25%;
  }
  .col-xs-push-7 {
    left: 29.1666666667%;
  }
  .col-xs-push-8 {
    left: 33.3333333333%;
  }
  .col-xs-push-9 {
    left: 37.5%;
  }
  .col-xs-push-10 {
    left: 41.6666666667%;
  }
  .col-xs-push-11 {
    left: 45.8333333333%;
  }
  .col-xs-push-12 {
    left: 50%;
  }
  .col-xs-push-13 {
    left: 54.1666666667%;
  }
  .col-xs-push-14 {
    left: 58.3333333333%;
  }
  .col-xs-push-15 {
    left: 62.5%;
  }
  .col-xs-push-16 {
    left: 66.6666666667%;
  }
  .col-xs-push-17 {
    left: 70.8333333333%;
  }
  .col-xs-push-18 {
    left: 75%;
  }
  .col-xs-push-19 {
    left: 79.1666666667%;
  }
  .col-xs-push-20 {
    left: 83.3333333333%;
  }
  .col-xs-push-21 {
    left: 87.5%;
  }
  .col-xs-push-22 {
    left: 91.6666666667%;
  }
  .col-xs-push-23 {
    left: 95.8333333333%;
  }
  .col-xs-push-24 {
    left: 100%;
  }
  .col-xs-offset-0 {
    margin-left: 0;
  }
  .col-xs-offset-1 {
    margin-left: 4.1666666667%;
  }
  .col-xs-offset-2 {
    margin-left: 8.3333333333%;
  }
  .col-xs-offset-3 {
    margin-left: 12.5%;
  }
  .col-xs-offset-4 {
    margin-left: 16.6666666667%;
  }
  .col-xs-offset-5 {
    margin-left: 20.8333333333%;
  }
  .col-xs-offset-6 {
    margin-left: 25%;
  }
  .col-xs-offset-7 {
    margin-left: 29.1666666667%;
  }
  .col-xs-offset-8 {
    margin-left: 33.3333333333%;
  }
  .col-xs-offset-9 {
    margin-left: 37.5%;
  }
  .col-xs-offset-10 {
    margin-left: 41.6666666667%;
  }
  .col-xs-offset-11 {
    margin-left: 45.8333333333%;
  }
  .col-xs-offset-12 {
    margin-left: 50%;
  }
  .col-xs-offset-13 {
    margin-left: 54.1666666667%;
  }
  .col-xs-offset-14 {
    margin-left: 58.3333333333%;
  }
  .col-xs-offset-15 {
    margin-left: 62.5%;
  }
  .col-xs-offset-16 {
    margin-left: 66.6666666667%;
  }
  .col-xs-offset-17 {
    margin-left: 70.8333333333%;
  }
  .col-xs-offset-18 {
    margin-left: 75%;
  }
  .col-xs-offset-19 {
    margin-left: 79.1666666667%;
  }
  .col-xs-offset-20 {
    margin-left: 83.3333333333%;
  }
  .col-xs-offset-21 {
    margin-left: 87.5%;
  }
  .col-xs-offset-22 {
    margin-left: 91.6666666667%;
  }
  .col-xs-offset-23 {
    margin-left: 95.8333333333%;
  }
  .col-xs-offset-24 {
    margin-left: 100%;
  }
  @media (min-width: 767px) {
    .col-sm-1,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-13,
    .col-sm-14,
    .col-sm-15,
    .col-sm-16,
    .col-sm-17,
    .col-sm-18,
    .col-sm-19,
    .col-sm-20,
    .col-sm-21,
    .col-sm-22,
    .col-sm-23,
    .col-sm-24 {
      float: left;
    }
    .col-sm-1 {
      width: 4.1666666667%;
    }
    .col-sm-2 {
      width: 8.3333333333%;
    }
    .col-sm-3 {
      width: 12.5%;
    }
    .col-sm-4 {
      width: 16.6666666667%;
    }
    .col-sm-5 {
      width: 20.8333333333%;
    }
    .col-sm-6 {
      width: 25%;
    }
    .col-sm-7 {
      width: 29.1666666667%;
    }
    .col-sm-8 {
      width: 33.3333333333%;
    }
    .col-sm-9 {
      width: 37.5%;
    }
    .col-sm-10 {
      width: 41.6666666667%;
    }
    .col-sm-11 {
      width: 45.8333333333%;
    }
    .col-sm-12 {
      width: 50%;
    }
    .col-sm-13 {
      width: 54.1666666667%;
    }
    .col-sm-14 {
      width: 58.3333333333%;
    }
    .col-sm-15 {
      width: 62.5%;
    }
    .col-sm-16 {
      width: 66.6666666667%;
    }
    .col-sm-17 {
      width: 70.8333333333%;
    }
    .col-sm-18 {
      width: 75%;
    }
    .col-sm-19 {
      width: 79.1666666667%;
    }
    .col-sm-20 {
      width: 83.3333333333%;
    }
    .col-sm-21 {
      width: 87.5%;
    }
    .col-sm-22 {
      width: 91.6666666667%;
    }
    .col-sm-23 {
      width: 95.8333333333%;
    }
    .col-sm-24 {
      width: 100%;
    }
    .col-sm-pull-0 {
      right: auto;
    }
    .col-sm-pull-1 {
      right: 4.1666666667%;
    }
    .col-sm-pull-2 {
      right: 8.3333333333%;
    }
    .col-sm-pull-3 {
      right: 12.5%;
    }
    .col-sm-pull-4 {
      right: 16.6666666667%;
    }
    .col-sm-pull-5 {
      right: 20.8333333333%;
    }
    .col-sm-pull-6 {
      right: 25%;
    }
    .col-sm-pull-7 {
      right: 29.1666666667%;
    }
    .col-sm-pull-8 {
      right: 33.3333333333%;
    }
    .col-sm-pull-9 {
      right: 37.5%;
    }
    .col-sm-pull-10 {
      right: 41.6666666667%;
    }
    .col-sm-pull-11 {
      right: 45.8333333333%;
    }
    .col-sm-pull-12 {
      right: 50%;
    }
    .col-sm-pull-13 {
      right: 54.1666666667%;
    }
    .col-sm-pull-14 {
      right: 58.3333333333%;
    }
    .col-sm-pull-15 {
      right: 62.5%;
    }
    .col-sm-pull-16 {
      right: 66.6666666667%;
    }
    .col-sm-pull-17 {
      right: 70.8333333333%;
    }
    .col-sm-pull-18 {
      right: 75%;
    }
    .col-sm-pull-19 {
      right: 79.1666666667%;
    }
    .col-sm-pull-20 {
      right: 83.3333333333%;
    }
    .col-sm-pull-21 {
      right: 87.5%;
    }
    .col-sm-pull-22 {
      right: 91.6666666667%;
    }
    .col-sm-pull-23 {
      right: 95.8333333333%;
    }
    .col-sm-pull-24 {
      right: 100%;
    }
    .col-sm-push-0 {
      left: auto;
    }
    .col-sm-push-1 {
      left: 4.1666666667%;
    }
    .col-sm-push-2 {
      left: 8.3333333333%;
    }
    .col-sm-push-3 {
      left: 12.5%;
    }
    .col-sm-push-4 {
      left: 16.6666666667%;
    }
    .col-sm-push-5 {
      left: 20.8333333333%;
    }
    .col-sm-push-6 {
      left: 25%;
    }
    .col-sm-push-7 {
      left: 29.1666666667%;
    }
    .col-sm-push-8 {
      left: 33.3333333333%;
    }
    .col-sm-push-9 {
      left: 37.5%;
    }
    .col-sm-push-10 {
      left: 41.6666666667%;
    }
    .col-sm-push-11 {
      left: 45.8333333333%;
    }
    .col-sm-push-12 {
      left: 50%;
    }
    .col-sm-push-13 {
      left: 54.1666666667%;
    }
    .col-sm-push-14 {
      left: 58.3333333333%;
    }
    .col-sm-push-15 {
      left: 62.5%;
    }
    .col-sm-push-16 {
      left: 66.6666666667%;
    }
    .col-sm-push-17 {
      left: 70.8333333333%;
    }
    .col-sm-push-18 {
      left: 75%;
    }
    .col-sm-push-19 {
      left: 79.1666666667%;
    }
    .col-sm-push-20 {
      left: 83.3333333333%;
    }
    .col-sm-push-21 {
      left: 87.5%;
    }
    .col-sm-push-22 {
      left: 91.6666666667%;
    }
    .col-sm-push-23 {
      left: 95.8333333333%;
    }
    .col-sm-push-24 {
      left: 100%;
    }
    .col-sm-offset-0 {
      margin-left: 0;
    }
    .col-sm-offset-1 {
      margin-left: 4.1666666667%;
    }
    .col-sm-offset-2 {
      margin-left: 8.3333333333%;
    }
    .col-sm-offset-3 {
      margin-left: 12.5%;
    }
    .col-sm-offset-4 {
      margin-left: 16.6666666667%;
    }
    .col-sm-offset-5 {
      margin-left: 20.8333333333%;
    }
    .col-sm-offset-6 {
      margin-left: 25%;
    }
    .col-sm-offset-7 {
      margin-left: 29.1666666667%;
    }
    .col-sm-offset-8 {
      margin-left: 33.3333333333%;
    }
    .col-sm-offset-9 {
      margin-left: 37.5%;
    }
    .col-sm-offset-10 {
      margin-left: 41.6666666667%;
    }
    .col-sm-offset-11 {
      margin-left: 45.8333333333%;
    }
    .col-sm-offset-12 {
      margin-left: 50%;
    }
    .col-sm-offset-13 {
      margin-left: 54.1666666667%;
    }
    .col-sm-offset-14 {
      margin-left: 58.3333333333%;
    }
    .col-sm-offset-15 {
      margin-left: 62.5%;
    }
    .col-sm-offset-16 {
      margin-left: 66.6666666667%;
    }
    .col-sm-offset-17 {
      margin-left: 70.8333333333%;
    }
    .col-sm-offset-18 {
      margin-left: 75%;
    }
    .col-sm-offset-19 {
      margin-left: 79.1666666667%;
    }
    .col-sm-offset-20 {
      margin-left: 83.3333333333%;
    }
    .col-sm-offset-21 {
      margin-left: 87.5%;
    }
    .col-sm-offset-22 {
      margin-left: 91.6666666667%;
    }
    .col-sm-offset-23 {
      margin-left: 95.8333333333%;
    }
    .col-sm-offset-24 {
      margin-left: 100%;
    }
  }
  @media (min-width: 992px) {
    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-13,
    .col-md-14,
    .col-md-15,
    .col-md-16,
    .col-md-17,
    .col-md-18,
    .col-md-19,
    .col-md-20,
    .col-md-21,
    .col-md-22,
    .col-md-23,
    .col-md-24 {
      float: left;
    }
    .col-md-1 {
      width: 4.1666666667%;
    }
    .col-md-2 {
      width: 8.3333333333%;
    }
    .col-md-3 {
      width: 12.5%;
    }
    .col-md-4 {
      width: 16.6666666667%;
    }
    .col-md-5 {
      width: 20.8333333333%;
    }
    .col-md-6 {
      width: 25%;
    }
    .col-md-7 {
      width: 29.1666666667%;
    }
    .col-md-8 {
      width: 33.3333333333%;
    }
    .col-md-9 {
      width: 37.5%;
    }
    .col-md-10 {
      width: 41.6666666667%;
    }
    .col-md-11 {
      width: 45.8333333333%;
    }
    .col-md-12 {
      width: 50%;
    }
    .col-md-13 {
      width: 54.1666666667%;
    }
    .col-md-14 {
      width: 58.3333333333%;
    }
    .col-md-15 {
      width: 62.5%;
    }
    .col-md-16 {
      width: 66.6666666667%;
    }
    .col-md-17 {
      width: 70.8333333333%;
    }
    .col-md-18 {
      width: 75%;
    }
    .col-md-19 {
      width: 79.1666666667%;
    }
    .col-md-20 {
      width: 83.3333333333%;
    }
    .col-md-21 {
      width: 87.5%;
    }
    .col-md-22 {
      width: 91.6666666667%;
    }
    .col-md-23 {
      width: 95.8333333333%;
    }
    .col-md-24 {
      width: 100%;
    }
    .col-md-pull-0 {
      right: auto;
    }
    .col-md-pull-1 {
      right: 4.1666666667%;
    }
    .col-md-pull-2 {
      right: 8.3333333333%;
    }
    .col-md-pull-3 {
      right: 12.5%;
    }
    .col-md-pull-4 {
      right: 16.6666666667%;
    }
    .col-md-pull-5 {
      right: 20.8333333333%;
    }
    .col-md-pull-6 {
      right: 25%;
    }
    .col-md-pull-7 {
      right: 29.1666666667%;
    }
    .col-md-pull-8 {
      right: 33.3333333333%;
    }
    .col-md-pull-9 {
      right: 37.5%;
    }
    .col-md-pull-10 {
      right: 41.6666666667%;
    }
    .col-md-pull-11 {
      right: 45.8333333333%;
    }
    .col-md-pull-12 {
      right: 50%;
    }
    .col-md-pull-13 {
      right: 54.1666666667%;
    }
    .col-md-pull-14 {
      right: 58.3333333333%;
    }
    .col-md-pull-15 {
      right: 62.5%;
    }
    .col-md-pull-16 {
      right: 66.6666666667%;
    }
    .col-md-pull-17 {
      right: 70.8333333333%;
    }
    .col-md-pull-18 {
      right: 75%;
    }
    .col-md-pull-19 {
      right: 79.1666666667%;
    }
    .col-md-pull-20 {
      right: 83.3333333333%;
    }
    .col-md-pull-21 {
      right: 87.5%;
    }
    .col-md-pull-22 {
      right: 91.6666666667%;
    }
    .col-md-pull-23 {
      right: 95.8333333333%;
    }
    .col-md-pull-24 {
      right: 100%;
    }
    .col-md-push-0 {
      left: auto;
    }
    .col-md-push-1 {
      left: 4.1666666667%;
    }
    .col-md-push-2 {
      left: 8.3333333333%;
    }
    .col-md-push-3 {
      left: 12.5%;
    }
    .col-md-push-4 {
      left: 16.6666666667%;
    }
    .col-md-push-5 {
      left: 20.8333333333%;
    }
    .col-md-push-6 {
      left: 25%;
    }
    .col-md-push-7 {
      left: 29.1666666667%;
    }
    .col-md-push-8 {
      left: 33.3333333333%;
    }
    .col-md-push-9 {
      left: 37.5%;
    }
    .col-md-push-10 {
      left: 41.6666666667%;
    }
    .col-md-push-11 {
      left: 45.8333333333%;
    }
    .col-md-push-12 {
      left: 50%;
    }
    .col-md-push-13 {
      left: 54.1666666667%;
    }
    .col-md-push-14 {
      left: 58.3333333333%;
    }
    .col-md-push-15 {
      left: 62.5%;
    }
    .col-md-push-16 {
      left: 66.6666666667%;
    }
    .col-md-push-17 {
      left: 70.8333333333%;
    }
    .col-md-push-18 {
      left: 75%;
    }
    .col-md-push-19 {
      left: 79.1666666667%;
    }
    .col-md-push-20 {
      left: 83.3333333333%;
    }
    .col-md-push-21 {
      left: 87.5%;
    }
    .col-md-push-22 {
      left: 91.6666666667%;
    }
    .col-md-push-23 {
      left: 95.8333333333%;
    }
    .col-md-push-24 {
      left: 100%;
    }
    .col-md-offset-0 {
      margin-left: 0;
    }
    .col-md-offset-1 {
      margin-left: 4.1666666667%;
    }
    .col-md-offset-2 {
      margin-left: 8.3333333333%;
    }
    .col-md-offset-3 {
      margin-left: 12.5%;
    }
    .col-md-offset-4 {
      margin-left: 16.6666666667%;
    }
    .col-md-offset-5 {
      margin-left: 20.8333333333%;
    }
    .col-md-offset-6 {
      margin-left: 25%;
    }
    .col-md-offset-7 {
      margin-left: 29.1666666667%;
    }
    .col-md-offset-8 {
      margin-left: 33.3333333333%;
    }
    .col-md-offset-9 {
      margin-left: 37.5%;
    }
    .col-md-offset-10 {
      margin-left: 41.6666666667%;
    }
    .col-md-offset-11 {
      margin-left: 45.8333333333%;
    }
    .col-md-offset-12 {
      margin-left: 50%;
    }
    .col-md-offset-13 {
      margin-left: 54.1666666667%;
    }
    .col-md-offset-14 {
      margin-left: 58.3333333333%;
    }
    .col-md-offset-15 {
      margin-left: 62.5%;
    }
    .col-md-offset-16 {
      margin-left: 66.6666666667%;
    }
    .col-md-offset-17 {
      margin-left: 70.8333333333%;
    }
    .col-md-offset-18 {
      margin-left: 75%;
    }
    .col-md-offset-19 {
      margin-left: 79.1666666667%;
    }
    .col-md-offset-20 {
      margin-left: 83.3333333333%;
    }
    .col-md-offset-21 {
      margin-left: 87.5%;
    }
    .col-md-offset-22 {
      margin-left: 91.6666666667%;
    }
    .col-md-offset-23 {
      margin-left: 95.8333333333%;
    }
    .col-md-offset-24 {
      margin-left: 100%;
    }
  }
  @media (min-width: 1200px) {
    .col-lg-1,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-13,
    .col-lg-14,
    .col-lg-15,
    .col-lg-16,
    .col-lg-17,
    .col-lg-18,
    .col-lg-19,
    .col-lg-20,
    .col-lg-21,
    .col-lg-22,
    .col-lg-23,
    .col-lg-24 {
      float: left;
    }
    .col-lg-1 {
      width: 4.1666666667%;
    }
    .col-lg-2 {
      width: 8.3333333333%;
    }
    .col-lg-3 {
      width: 12.5%;
    }
    .col-lg-4 {
      width: 16.6666666667%;
    }
    .col-lg-5 {
      width: 20.8333333333%;
    }
    .col-lg-6 {
      width: 25%;
    }
    .col-lg-7 {
      width: 29.1666666667%;
    }
    .col-lg-8 {
      width: 33.3333333333%;
    }
    .col-lg-9 {
      width: 37.5%;
    }
    .col-lg-10 {
      width: 41.6666666667%;
    }
    .col-lg-11 {
      width: 45.8333333333%;
    }
    .col-lg-12 {
      width: 50%;
    }
    .col-lg-13 {
      width: 54.1666666667%;
    }
    .col-lg-14 {
      width: 58.3333333333%;
    }
    .col-lg-15 {
      width: 62.5%;
    }
    .col-lg-16 {
      width: 66.6666666667%;
    }
    .col-lg-17 {
      width: 70.8333333333%;
    }
    .col-lg-18 {
      width: 75%;
    }
    .col-lg-19 {
      width: 79.1666666667%;
    }
    .col-lg-20 {
      width: 83.3333333333%;
    }
    .col-lg-21 {
      width: 87.5%;
    }
    .col-lg-22 {
      width: 91.6666666667%;
    }
    .col-lg-23 {
      width: 95.8333333333%;
    }
    .col-lg-24 {
      width: 100%;
    }
    .col-lg-pull-0 {
      right: auto;
    }
    .col-lg-pull-1 {
      right: 4.1666666667%;
    }
    .col-lg-pull-2 {
      right: 8.3333333333%;
    }
    .col-lg-pull-3 {
      right: 12.5%;
    }
    .col-lg-pull-4 {
      right: 16.6666666667%;
    }
    .col-lg-pull-5 {
      right: 20.8333333333%;
    }
    .col-lg-pull-6 {
      right: 25%;
    }
    .col-lg-pull-7 {
      right: 29.1666666667%;
    }
    .col-lg-pull-8 {
      right: 33.3333333333%;
    }
    .col-lg-pull-9 {
      right: 37.5%;
    }
    .col-lg-pull-10 {
      right: 41.6666666667%;
    }
    .col-lg-pull-11 {
      right: 45.8333333333%;
    }
    .col-lg-pull-12 {
      right: 50%;
    }
    .col-lg-pull-13 {
      right: 54.1666666667%;
    }
    .col-lg-pull-14 {
      right: 58.3333333333%;
    }
    .col-lg-pull-15 {
      right: 62.5%;
    }
    .col-lg-pull-16 {
      right: 66.6666666667%;
    }
    .col-lg-pull-17 {
      right: 70.8333333333%;
    }
    .col-lg-pull-18 {
      right: 75%;
    }
    .col-lg-pull-19 {
      right: 79.1666666667%;
    }
    .col-lg-pull-20 {
      right: 83.3333333333%;
    }
    .col-lg-pull-21 {
      right: 87.5%;
    }
    .col-lg-pull-22 {
      right: 91.6666666667%;
    }
    .col-lg-pull-23 {
      right: 95.8333333333%;
    }
    .col-lg-pull-24 {
      right: 100%;
    }
    .col-lg-push-0 {
      left: auto;
    }
    .col-lg-push-1 {
      left: 4.1666666667%;
    }
    .col-lg-push-2 {
      left: 8.3333333333%;
    }
    .col-lg-push-3 {
      left: 12.5%;
    }
    .col-lg-push-4 {
      left: 16.6666666667%;
    }
    .col-lg-push-5 {
      left: 20.8333333333%;
    }
    .col-lg-push-6 {
      left: 25%;
    }
    .col-lg-push-7 {
      left: 29.1666666667%;
    }
    .col-lg-push-8 {
      left: 33.3333333333%;
    }
    .col-lg-push-9 {
      left: 37.5%;
    }
    .col-lg-push-10 {
      left: 41.6666666667%;
    }
    .col-lg-push-11 {
      left: 45.8333333333%;
    }
    .col-lg-push-12 {
      left: 50%;
    }
    .col-lg-push-13 {
      left: 54.1666666667%;
    }
    .col-lg-push-14 {
      left: 58.3333333333%;
    }
    .col-lg-push-15 {
      left: 62.5%;
    }
    .col-lg-push-16 {
      left: 66.6666666667%;
    }
    .col-lg-push-17 {
      left: 70.8333333333%;
    }
    .col-lg-push-18 {
      left: 75%;
    }
    .col-lg-push-19 {
      left: 79.1666666667%;
    }
    .col-lg-push-20 {
      left: 83.3333333333%;
    }
    .col-lg-push-21 {
      left: 87.5%;
    }
    .col-lg-push-22 {
      left: 91.6666666667%;
    }
    .col-lg-push-23 {
      left: 95.8333333333%;
    }
    .col-lg-push-24 {
      left: 100%;
    }
    .col-lg-offset-0 {
      margin-left: 0;
    }
    .col-lg-offset-1 {
      margin-left: 4.1666666667%;
    }
    .col-lg-offset-2 {
      margin-left: 8.3333333333%;
    }
    .col-lg-offset-3 {
      margin-left: 12.5%;
    }
    .col-lg-offset-4 {
      margin-left: 16.6666666667%;
    }
    .col-lg-offset-5 {
      margin-left: 20.8333333333%;
    }
    .col-lg-offset-6 {
      margin-left: 25%;
    }
    .col-lg-offset-7 {
      margin-left: 29.1666666667%;
    }
    .col-lg-offset-8 {
      margin-left: 33.3333333333%;
    }
    .col-lg-offset-9 {
      margin-left: 37.5%;
    }
    .col-lg-offset-10 {
      margin-left: 41.6666666667%;
    }
    .col-lg-offset-11 {
      margin-left: 45.8333333333%;
    }
    .col-lg-offset-12 {
      margin-left: 50%;
    }
    .col-lg-offset-13 {
      margin-left: 54.1666666667%;
    }
    .col-lg-offset-14 {
      margin-left: 58.3333333333%;
    }
    .col-lg-offset-15 {
      margin-left: 62.5%;
    }
    .col-lg-offset-16 {
      margin-left: 66.6666666667%;
    }
    .col-lg-offset-17 {
      margin-left: 70.8333333333%;
    }
    .col-lg-offset-18 {
      margin-left: 75%;
    }
    .col-lg-offset-19 {
      margin-left: 79.1666666667%;
    }
    .col-lg-offset-20 {
      margin-left: 83.3333333333%;
    }
    .col-lg-offset-21 {
      margin-left: 87.5%;
    }
    .col-lg-offset-22 {
      margin-left: 91.6666666667%;
    }
    .col-lg-offset-23 {
      margin-left: 95.8333333333%;
    }
    .col-lg-offset-24 {
      margin-left: 100%;
    }
  }
`;

export const baseFormCSSWrapper = css`
  fieldset {
    margin: 0;
    min-width: 0;
  }
  fieldset,
  legend {
    padding: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    margin-bottom: 25px;
    font-size: 22.5px;
    line-height: inherit;
    color: #333;
    border-bottom: 1px solid #e5e5e5;
  }
  label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
  }
  input[type="search"] {
    box-sizing: border-box;
  }
  input[type="checkbox"],
  input[type="radio"] {
    margin: 4px 0 0;
    line-height: normal;
  }
  input[type="file"] {
    display: block;
  }
  input[type="range"] {
    display: block;
    width: 100%;
  }
  select[multiple],
  select[size] {
    height: auto;
  }
  input[type="checkbox"]:focus,
  input[type="file"]:focus,
  input[type="radio"]:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  .btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 15px;
    line-height: 1.7142857143;
    border-radius: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .btn.active.focus,
  .btn.active:focus,
  .btn.focus,
  .btn:active.focus,
  .btn:active:focus,
  .btn:focus {
    outline: thin dotted;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  .btn.focus,
  .btn:focus,
  .btn:hover {
    color: #333;
    text-decoration: none;
  }
  .btn.active,
  .btn:active {
    outline: 0;
    background-image: none;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  }
  .btn.disabled,
  .btn[disabled],
  fieldset[disabled] .btn {
    cursor: not-allowed;
    opacity: 0.65;
    filter: alpha(opacity=65);
    box-shadow: none;
  }
  a.btn.disabled,
  fieldset[disabled] a.btn {
    pointer-events: none;
  }
  .btn-primary {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }
  .btn-primary.focus,
  .btn-primary:focus {
    color: #fff;
    background-color: #286090;
    border-color: #122b40;
  }
  .btn-primary.active,
  .btn-primary:active,
  .btn-primary:hover,
  .open > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #286090;
    border-color: #204d74;
  }
  .btn-primary.active.focus,
  .btn-primary.active:focus,
  .btn-primary.active:hover,
  .btn-primary:active.focus,
  .btn-primary:active:focus,
  .btn-primary:active:hover,
  .open > .btn-primary.dropdown-toggle.focus,
  .open > .btn-primary.dropdown-toggle:focus,
  .open > .btn-primary.dropdown-toggle:hover {
    color: #fff;
    background-color: #204d74;
    border-color: #122b40;
  }
  .btn-primary.active,
  .btn-primary:active,
  .open > .btn-primary.dropdown-toggle {
    background-image: none;
  }
  .btn-primary.disabled,
  .btn-primary.disabled.active,
  .btn-primary.disabled.focus,
  .btn-primary.disabled:active,
  .btn-primary.disabled:focus,
  .btn-primary.disabled:hover,
  .btn-primary[disabled],
  .btn-primary[disabled].active,
  .btn-primary[disabled].focus,
  .btn-primary[disabled]:active,
  .btn-primary[disabled]:focus,
  .btn-primary[disabled]:hover {
    background-color: #337ab7;
    border-color: #2e6da4;
  }
`;

export const baseButtonCSSWrapper = css`
  .app-section .node--header {
    padding-left: 15px;
    padding-right: 15px;
  }
  .app-section .node--title {
    font-size: 32px;
    color: #4a4a4a;
    line-height: 1.4;
    text-align: center;
    -webkit-font-smoothing: antialiased;
  }
  @media (max-width: 992px) {
    .app-section .node--title {
      font-size: 27px !important;
    }
  }
  @media (max-width: 767px) {
    .app-section .node--title {
      font-size: 24px !important;
      padding-top: 5px;
      margin-bottom: 5px;
    }
  }
  .app-section .node--description,
  .app-section .node--lead {
    font-size: 16px;
    color: #939393;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    text-align: center;
    line-height: 1.4;
  }
  @media (max-width: 992px) {
    .app-section .node--description,
    .app-section .node--lead {
      font-size: 18px !important;
    }
  }
  @media (max-width: 767px) {
    .app-section .node--description,
    .app-section .node--lead {
      font-size: 16px !important;
    }
  }
  .btn {
    transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    border-radius: 25px;
    height: 36px;
    line-height: 36px;
    background-color: #2f7cd5;
    border: none;
    font-size: 16px;
    font-weight: 600;
    padding: 0 30px;
    text-decoration: none;
    color: #fff;
    vertical-align: bottom;
    position: relative;
    -webkit-font-smoothing: antialiased;
    background-image: linear-gradient(0deg, #0964c8, #007aff);
  }
  @media (max-width: 767px) {
    .btn {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .btn:active,
  .btn:focus,
  .btn:hover {
    color: #fff;
    background-image: linear-gradient(-180deg, #0964c8, #007aff);
    box-shadow: 0 0 0 transparent;
    background-color: transparent;
  }
  .btn.btn-primary {
    background-color: transparent;
    border: none;
    color: #fff;
    background-image: linear-gradient(-180deg, #575757, #232124);
  }
  .btn.btn-primary:active,
  .btn.btn-primary:focus,
  .btn.btn-primary:hover {
    color: #fff;
    background-image: linear-gradient(-180deg, #232124, #575757);
  }
  .btn.btn-secondary {
    background-color: transparent;
    border: none;
    color: #fff;
    background-image: linear-gradient(180deg, #4c4c4c, #1c1c1c 98%);
  }
  .btn.btn-secondary:active,
  .btn.btn-secondary:focus,
  .btn.btn-secondary:hover {
    color: #fff;
    background-image: linear-gradient(-180deg, #1c1c1c, #4c4c4c);
  }
  .btn.btn-tertiary {
    background-color: transparent;
    border: 2px solid #e6e6e6;
    background-image: linear-gradient(-180deg, #e6e6e6, #cdcdcd) !important;
    color: #000;
    font-weight: 600;
  }
  .btn.btn-tertiary:active,
  .btn.btn-tertiary:focus,
  .btn.btn-tertiary:hover {
    background-color: #bcbcbc;
    color: #000;
    background-image: linear-gradient(-180deg, #cdcdcd, #e6e6e6) !important;
  }
  .btn.btn-link {
    padding-left: 18px;
    padding-right: 18px;
    background-position: 100% 52%;
  }
  .btn.btn-link,
  .btn.btn-link:active,
  .btn.btn-link:focus,
  .btn.btn-link:hover {
    color: #007aff;
    background-image: none;
    box-shadow: 0 0 0 transparent;
  }
  .btn.btn-link,
  .btn.btn-link:active,
  .btn.btn-link:focus,
  .btn.btn-link:hover {
    background-color: transparent;
  }
  .btn.btn-link {
    border-color: transparent;
  }
  .btn-type-one {
    transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    font-size: 13px;
    color: #58585b;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    border: 2px solid #58585b;
    border-radius: 6px;
    line-height: 32px;
    padding-left: 20px;
    padding-right: 20px;
    min-width: 123px;
  }
  .btn-type-one:active,
  .btn-type-one:focus,
  .btn-type-one:hover {
    text-decoration: none;
    background-color: #58585b;
    color: #fff;
  }
  .btn-type-two {
    transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    font-size: 13px;
    color: #007afe;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    border: 2px solid #007afe;
    background-color: #007afe;
    color: #fff;
    border-radius: 6px;
    line-height: 32px;
    padding-left: 20px;
    padding-right: 20px;
    min-width: 123px;
  }
  .btn-type-two:active,
  .btn-type-two:focus,
  .btn-type-two:hover {
    text-decoration: none;
    background-color: transparent;
    color: #007afe;
  }
  .btn-type-three {
    transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    font-size: 13px;
    color: #fff;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    border: 2px solid #58585b;
    background-color: #58585b;
    border-radius: 6px;
    line-height: 32px;
    padding-left: 20px;
    padding-right: 20px;
    min-width: 123px;
  }
  .btn-type-three:active,
  .btn-type-three:focus,
  .btn-type-three:hover {
    text-decoration: none;
    background-color: #fff;
    color: #58585b;
  }
`;

export const baseSupplementalCSSWrapper = css`
  .clearfix:after,
  .clearfix:before {
    content: " ";
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .pull-right {
    float: right !important;
  }
  .pull-left {
    float: left !important;
  }
  .hide {
    display: none !important;
  }
  .show {
    display: block !important;
  }
  .invisible {
    visibility: hidden;
  }
  .text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
  }
  .hidden {
    display: none !important;
  }
  .affix {
    position: fixed;
  }
  @-ms-viewport {
    width: device-width;
  }
  .visible-lg,
  .visible-lg-block,
  .visible-lg-inline,
  .visible-lg-inline-block,
  .visible-md,
  .visible-md-block,
  .visible-md-inline,
  .visible-md-inline-block,
  .visible-sm,
  .visible-sm-block,
  .visible-sm-inline,
  .visible-sm-inline-block,
  .visible-xs,
  .visible-xs-block,
  .visible-xs-inline,
  .visible-xs-inline-block {
    display: none !important;
  }
  @media (max-width: 766px) {
    .visible-xs {
      display: block !important;
    }
    table.visible-xs {
      display: table !important;
    }
    tr.visible-xs {
      display: table-row !important;
    }
    td.visible-xs,
    th.visible-xs {
      display: table-cell !important;
    }
  }
  @media (max-width: 766px) {
    .visible-xs-block {
      display: block !important;
    }
  }
  @media (max-width: 766px) {
    .visible-xs-inline {
      display: inline !important;
    }
  }
  @media (max-width: 766px) {
    .visible-xs-inline-block {
      display: inline-block !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .visible-sm {
      display: block !important;
    }
    table.visible-sm {
      display: table !important;
    }
    tr.visible-sm {
      display: table-row !important;
    }
    td.visible-sm,
    th.visible-sm {
      display: table-cell !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .visible-sm-block {
      display: block !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .visible-sm-inline {
      display: inline !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .visible-sm-inline-block {
      display: inline-block !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md {
      display: block !important;
    }
    table.visible-md {
      display: table !important;
    }
    tr.visible-md {
      display: table-row !important;
    }
    td.visible-md,
    th.visible-md {
      display: table-cell !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-block {
      display: block !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-inline {
      display: inline !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-inline-block {
      display: inline-block !important;
    }
  }
  @media (min-width: 1200px) {
    .visible-lg {
      display: block !important;
    }
    table.visible-lg {
      display: table !important;
    }
    tr.visible-lg {
      display: table-row !important;
    }
    td.visible-lg,
    th.visible-lg {
      display: table-cell !important;
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-block {
      display: block !important;
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-inline {
      display: inline !important;
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-inline-block {
      display: inline-block !important;
    }
  }
  @media (max-width: 766px) {
    .hidden-xs {
      display: none !important;
    }
  }
  @media (min-width: 767px) and (max-width: 991px) {
    .hidden-sm {
      display: none !important;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .hidden-md {
      display: none !important;
    }
  }
  @media (min-width: 1200px) {
    .hidden-lg {
      display: none !important;
    }
  }
  .visible-print {
    display: none !important;
  }
  @media print {
    .visible-print {
      display: block !important;
    }
    table.visible-print {
      display: table !important;
    }
    tr.visible-print {
      display: table-row !important;
    }
    td.visible-print,
    th.visible-print {
      display: table-cell !important;
    }
  }
  .visible-print-block {
    display: none !important;
  }
  @media print {
    .visible-print-block {
      display: block !important;
    }
  }
  .visible-print-inline {
    display: none !important;
  }
  @media print {
    .visible-print-inline {
      display: inline !important;
    }
  }
  .visible-print-inline-block {
    display: none !important;
  }
  @media print {
    .visible-print-inline-block {
      display: inline-block !important;
    }
  }
  @media print {
    .hidden-print {
      display: none !important;
    }
  }
`;
